import FS from '@isomorphic-git/lightning-fs';
import { Buffer } from 'buffer';
import * as Lucide from 'lucide-react';
import * as ReactECharts from 'echarts-for-react';
import type * as ReactRouterDOMTypes from 'react-router-dom';

declare global {
  interface Window {
    fs: any;
    pfs: any;
    miDir: string;
    Buffer: typeof Buffer;
    ethers: any;
    MakeInfinite: any;
    ReactECharts: any;
    THREE: any;
    Radix: any;
    DreamspaceElements: any;
    Lucide: any;
    ReactRouterDOM: typeof ReactRouterDOMTypes;
  }
}

// Initialization function to set up globals
export const initializeMakeInfinite = () => {
  if (typeof window !== 'undefined') {
    // Bundlers require Buffer to be defined on window
    window.Buffer = Buffer;
    // By default we use LightningFS but it is overridden when handling
    // a zip git repo
    window.fs = new FS('fs');
    window.pfs = window.fs.promises;

    // mi working directory
    window.miDir = '/mi';

    // Lucide icon workaround
    window.Lucide = Lucide;

    // ReactECharts workaround
    window.ReactECharts = ReactECharts.default;

    // Note: window.ReactRouterDOM is set by the consuming app (e.g., MakeInfinite.tsx)
    // to ensure a single instance of react-router-dom is used across the application.
    // Do NOT set it here as makeinfinite-ui now externalizes react-router-dom.
  }
};

// Application Exports
export {
  getTags,
  syncAndRetry,
  getUndoTargetCommitForFile,
  getRedoTargetCommitForFile,
  getHeadCommit,
  applySxtIgnore,
  listAllFiles,
  getCommits,
  checkoutCommit,
} from './git';
export { listDir } from './filesystem';
/** @deprecated Use MiniAppRenderContext instead */
export { MiniApp } from './components';
export { MiniAppRenderContext } from './components';
export { ProjectProvider, useAPI, useRGContext, RGProvider } from './contexts';
export { useProject } from './hooks';
export { useWebSocketManager } from './hooks/useWebSocketManager';
export {
  useB64UrlForProjectImage,
  loadProjectPages,
  loadLibraryComponents,
  loadProjectComponents,
  setTailwindTheme,
  useAppSettings,
  useAppVersions,
} from './utility';
export {
  RGComponent,
  RGDroppable,
  RGComponentErrorBoundary,
  RGEditLayout,
  RGPreviewLayout,
} from './components/RGLayout';

export { APIHandler } from './api';
export * from './apiProxy'; // Export all types from apiProxy
export { type Project, type FetchProjectResponse } from './types';

export * as DreamspaceElements from './components/DreamspaceElements';

export * as TailwindThemeContext from './contexts/tailwindThemeContext';
export * as TailwindThemeHooks from './hooks/tailwindThemeProvider';
